import { ReactNode, useState, MouseEvent, ChangeEvent, Dispatch, SetStateAction } from "react";
import { MetadataInfo } from "../../../utils/dataFormattingFns";
import { ReactComponent as EditIcon } from '../../../assets/Icons/adornments/Edit.svg';
import { ReactComponent as CheckIcon } from '../../../assets/Icons/adornments/Check.svg';
import { ReactComponent as CancelIcon } from '../../../assets/Icons/adornments/Close.svg';
import InputField from "../../Form/InputField";
import TagsEditableContainer from "./TagsEditableContainer";
import { CircularProgress } from "@mui/material";


export default function MetadataEditableMenuItem({
    metadataInfoItem,
    updateFunc,
    children,
}: {
    metadataInfoItem: MetadataInfo,
    updateFunc: (name: string, value: any) => Promise<void>,
    children: ReactNode,
}) {
    const [ isEditMode, setIsEditMode ] = useState(false);
    const [ isLoading, setIsLoading ] = useState(false);
    const [ newValue, setNewValue ] = useState<string | number | string[]>('');

    const { label, value: currentValue, type, editableParam, colspan } = metadataInfoItem;

    const enableEditMode = (e: MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        setIsEditMode(true);

        setNewValue(currentValue as string | number | string[]);
    };

    const confirmUpdate = async (e: MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        
        setIsLoading(true);
        try {
            await updateFunc(editableParam!, newValue);
            setIsEditMode(false);
        } catch (err:any) {
            console.log(err);
        }
        setIsLoading(false);
    }

    const cancelUpdate = (e: MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        setIsEditMode(false);
    };

    const handleInputChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setNewValue(e.target.value);
    }

    return (
        <div className={`w-full flex flex-col gap-1 justify-start items-start ${colspan === 2 ? 'col-span-2' : ''}`}>
            <div className="flex justify-start items-center gap-2">
                <label className="font-medium text-[12px]">{label}</label>
                <button onClick={enableEditMode} className='w-[14px] text-disable hover:text-primary transition-all'><EditIcon/></button>
            </div>

            {isEditMode ? (
                <>
                {type === 'text' || type === 'textarea' ? (
                    <div className='flex justify-start items-start gap-2 w-full'>
                        <InputField 
                            type={type}
                            id={editableParam!}
                            name={editableParam!}
                            handleChange={handleInputChange}
                            value={newValue as string | number}
                            placeholder={label}
                            isRequired={false}
                        />
                        <div className='flex justify-center items-center gap-1 h-[44px]'>
                            {isLoading ? (
                                <CircularProgress color='inherit' size={14}/>
                            ) : (
                                <button onClick={confirmUpdate} className='text-disable hover:text-primary transition-all w-[22px]'>
                                    <CheckIcon/>
                                </button>
                            )}
                            <button onClick={cancelUpdate} className='text-disable hover:text-primary transition-all w-[26px]'>
                                <CancelIcon/>
                            </button>
                        </div>
                    </div>
                ) : type === 'tags' ? (
                    <TagsEditableContainer 
                        arrValues={newValue as string[]}
                        setArrValues={setNewValue as Dispatch<SetStateAction<string[]>>}
                        confirmUpdate={confirmUpdate}
                        cancelUpdate={cancelUpdate}
                        isLoading={isLoading}
                    />
                ) : (
                    <></>
                )}
                </>
            ) : (
                <>{children}</>
            )}
        </div>
    )
}